package com.damda.design_system.ui.views.food_carts

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.right
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Text

@Composable
fun ShoppingCartIcon(
    cartCount: Int,
    onCartClick: () -> Unit,
    size: CSSSizeValue<CSSUnit.px> = 28.px, // 기본 크기를 28.px로 변경
) {
    Div(attrs = {
        style {
            position(Position.Relative)
            width(size)
            height(size)
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
        }
        onClick { onCartClick() }
    }) {
        Img(
            src = "ic_cart.png",
            attrs = {
                style {
                    width(100.percent)
                    height(100.percent)
                }
            }
        )

        if (cartCount > 0) {
            Div(attrs = {
                style {
                    position(Position.Absolute)
                    top((-3).px) // 위치를 모서리에 맞추기 위해 조정
                    right((-3).px) // 위치를 모서리에 맞추기 위해 조정
                    width(14.px) // 크기를 약간 키움
                    height(14.px) // 크기를 약간 키움
                    backgroundColor(Color.red)
                    borderRadius(50.percent)
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.Center)
                    alignItems(AlignItems.Center)
                    color(Color.white)
                    fontSize(9.px) // 폰트 크기를 약간 키움
                }
            }) {
                Text(cartCount.toString())
            }
        }
    }
}